import { useQuery } from 'react-query';
import axios from 'axios';

import { useAppSelector } from '@/app/hooks';
import { Campaign, CampaignsByWorkspace } from '@/models/Campaigns';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { selectCurrentWorkspace } from '@/modules/Dashboard/Workspaces/workspaceSlice';
import { AwsConfigApiGateway } from '@/utils/config/api';

import queryKeys from '../../modules/shared/query/queryKeys';

async function getCampaignsByWorkspaceId(token: string | undefined, workspaceId: string) {
  const response = await axios.get<CampaignsByWorkspace>(
    `${AwsConfigApiGateway.pooledTenantApiUrl}/workspaces/${workspaceId}/campaigns`,
    {
      headers: {
        'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
        Authorization: 'Bearer ' + token,
      },
    },
  );
  return response.data.data;
}

export function useGetCampaigns() {
  const { user } = useAuth();
  const workspace = useAppSelector(selectCurrentWorkspace);
  return useQuery<Campaign[]>({
    queryKey: [queryKeys.campaigns, workspace?.id],
    queryFn: () => getCampaignsByWorkspaceId(user?.signInUserSession.idToken.jwtToken, workspace?.id ?? ''),
  });
}
